import { useEffect, useState } from 'react'
import { Table } from 'antd'
import { useModel } from '../model'
import { YhTableSort } from '@/components/YhTableSort'
import { commonService } from '@/service/common'
import YhTootip from '@/components/YhTootip'
import { momentFormat } from '@/utils/utils'
import { SettingOutlined } from '@ant-design/icons'
import { setStatusTag } from '@/App'

const sortKey = 'exportRecord'

export function DataTable() {
    const { dataSource, pgCfg, loadData, columnsSetVisible, setColumnsSetVisible, orders, loading } = useModel()

    useEffect(() => {
        loadData()
        getColumns()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getRegularColumns = [
        {
            title: (
                <>
                    <span>
                        <SettingOutlined
                            onClick={() => {
                                setColumnsSetVisible(true)
                            }}
                        />
                    </span>
                    <span>序号</span>
                </>
            ),
            width: 80,
            fixed: 'left',
            align: 'center',
            render: (t, r, i) => i + 1,
        },
    ]
    const defaultColumns = [
        {
            title: '分支编码',
            width: 100,
            dataIndex: 'branch',
            isSet: true,
            render: (text) => <YhTootip text={text} style={{ width: '100px' }} />,
        },
        {
            title: '菜单名称',
            width: 140,
            dataIndex: 'menu',
            isSet: true,
            render: (text) => <YhTootip text={text} style={{ width: '140px' }} />,
        },
        {
            title: '文件名称',
            width: 140,
            dataIndex: 'fileName',
            isSet: true,
            render: (text) => <YhTootip text={text} style={{ width: '140px' }} />,
        },
        {
            title: '创建时间',
            width: 160,
            dataIndex: 'createTime',
            isSet: true,
            render: (text) => momentFormat(text),
        },
        {
            title: '开始时间',
            width: 160,
            dataIndex: 'startTime',
            isSet: true,
            render: (text) => momentFormat(text),
        },
        {
            title: '结束时间',
            width: 160,
            dataIndex: 'endTime',
            isSet: true,
            render: (text) => momentFormat(text),
        },
        {
            title: '单据状态',
            width: 100,
            dataIndex: 'status',
            isSet: true,
            render: (text) => {
                return setStatusTag(text)
            },
        },
        {
            title: '失败原因',
            width: 180,
            dataIndex: 'failMsg',
            isSet: true,
            render: (text) => <YhTootip text={text} style={{ width: '180px' }} />,
        },
        {
            title: '操作',
            width: 100,
            dataIndex: 'downloadUrl',
            isSet: true,
            render: (text) => (text ? <a href={text}>下载</a> : ''),
        },
    ]

    const [columns, setColumns] = useState<any[]>([])

    const getColumns = () => {
        commonService.userCustomizeConfigOne(sortKey).then((res) => {
            if (!res.retData) {
                setColumns([...getRegularColumns, ...defaultColumns])
            } else {
                let newColumns: any[] = [...getRegularColumns]
                let data = JSON.parse(res.retData.val)
                data.forEach((element) => {
                    if (element.isShow) {
                        newColumns.push({ ...defaultColumns.find((i) => i.dataIndex === element.key), sorter: element.isSort })
                    }
                })
                setColumns(newColumns)
            }
        })
    }

    const onSuccess = () => {
        setColumnsSetVisible(false)
        getColumns()
    }

    const onChange = (pagination, filters, sorter) => {
        if (sorter.field) {
            if (sorter.order) {
                orders.current = [{ column: sorter.field, asc: sorter.order === 'ascend' }]
            } else {
                orders.current = []
            }
            loadData()
        }
    }

    return (
        <>
            <Table
                rowKey={(record) => record.id || record.index}
                onChange={onChange}
                columns={columns}
                dataSource={dataSource}
                loading={loading}
                pagination={{
                    ...pgCfg,
                    position: ['bottomRight'],
                    showTotal: () => `共${pgCfg.total}条`,
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize })
                    },
                    showSizeChanger: true,
                }}
                bordered
                scroll={{ x: 'max-content', y: 'calc(100vh - 380px)' }}
            />
            <YhTableSort
                sortKey={sortKey}
                visible={columnsSetVisible}
                setVisible={setColumnsSetVisible}
                defaultColumns={defaultColumns}
                onSuccess={onSuccess}
            />
        </>
    )
}
